import AccountSummaryAccountCustomLinksWidget from "../AccountSummaryAccountCustomLinksWidget";

/**
 * @function AccountSummaryAccountCustomLinksWithTableRowWidget
 * @param {STRING} type - The account type, like "Checking" or "Savings". 
 * @returns {React.Component}
 * @description A component for the custom links (set through CCTM) shown beneath accounts in the widget
 * "Account Summary With Sortable Table and Links". This particular component is to wrap the links
 * in a table row in way where we can detect if there are any links rendered. Otherwise, a gap
 * is left in a parent component initializing "AccountSummaryAccountCustomLinksWidget" for example.
 */
export default function AccountSummaryAccountCustomLinksWithTableRowWidget(props) {
    const type = props.type ?? "";
    return <AccountSummaryAccountCustomLinksWidget type={ type } useTableWrapper={ true }/>;
}